module.exports = __webpack_public_path__ + "img/rcta-background.1effe981.jpg";